<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div id="menu">
    <v-app-bar v-if="toolbar" color="transparent" dense elevation="0" style="z-index: 149">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

      <v-toolbar-title>Title</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer style="z-index: 150" v-model="drawer" absolute temporary>
      <template v-slot:prepend>
        <v-list-item two-line v-if="userName && customerName">
          <v-list-item-content>
            <v-list-item-title>
              {{ userName }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ customerName }}
            </v-list-item-subtitle>
            <v-btn small v-if="$auth.isAdmin && !hasAdmin" @click="adminMode(true)">
              Admin-modus
            </v-btn>
            <v-btn small v-else-if="$auth.isAdmin && hasAdmin" @click="adminMode(false)">
              Normale-modes
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item-group active-class="none">
          <v-list-item @click="close()">
            <v-list-item-icon>
              <v-icon>mdi-close</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("App.close") }}</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="hasAdmin" @click="adminDiagnostics()">
            <v-list-item-icon>
              <v-icon>mdi-chart-multiline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.adminDiagnostics") }}</v-list-item-title>
          </v-list-item>

          <v-tooltip bottom :disabled="hasTracking || $auth.subscription == '__SUB_CIVIL_ROADPROFILER'">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-list-item @click="productionViewer()"
                  :disabled="!hasTracking && $auth.subscription != '__SUB_CIVIL_ROADPROFILER'">
                  <v-list-item-icon>
                    <v-icon>mdi-swap-horizontal</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title> {{ language.t("Menu.exportProduction") }}</v-list-item-title>
                </v-list-item>
              </span>
            </template>
            <span>{{ language.t("App.invalidSubscription") }}</span>
          </v-tooltip>

          <v-list-item @click="support()">
            <v-list-item-icon>
              <v-icon>mdi-face-agent</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.support") }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="projectList()">
            <v-list-item-icon>
              <v-icon>mdi-folder-open</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.projects") }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="accountDetails()">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.accountDetails") }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="customerUserList()">
            <v-list-item-icon>
              <v-icon>mdi-folder-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.manageUsers") }}</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="!$auth.hasOneCustomer" @click="switchCustomer()">
            <v-list-item-icon>
              <v-icon>mdi-swap-horizontal</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.switchCustomer") }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="settingsMenu()">
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.settings") }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="logout()">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ language.t("Menu.logout") }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
// TODO: menu items get active class which is not respected when popups are closed
export default {
  components: {},
  props: {
    toolbar: {
      required: false,
      default: true,
    },
    userName: {
      required: false,
    },
    customerName: {
      required: false,
    },
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    hasAdmin() {
      return this.$auth.functionGroups.includes(1)
    },
    hasTracking() {
      return this.$auth.functionGroups.includes(2)
    },
    hasMotionplanSpraypoints() {
      return this.$auth.functionGroups.includes(9)
    }
  },
  watch: {
  },
  methods: {
    adminMode(state) {
      if (state) {
        this.$axios.get(route('api.auth.getadminfunctions'))
          .then(res => {
            let functionGroups = []
            console.log(res)
            res.data.forEach(functionGroup => {
              functionGroups.push(functionGroup.functiongroupId)
            });
            this.$auth.functionGroups = functionGroups;
          })
      }
      else {
        this.$axios.get(route('api.auth.getcustomer'))
          .then(res => {
            console.log(res)
            this.$auth.functionGroups = res.data.functiongroups;
          })
      }

    },
    open() {
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },
    adminDiagnostics() {
      this.$emit("menuSelected", "adminDiagnostics");
      this.close();
    },
    productionViewer() {
      this.$emit("menuSelected", "ProductionViewer");
      this.close();
    },
    support() {
      this.$emit("menuSelected", "support");
      this.close();
    },
    customerUserList() {
      this.$emit("menuSelected", "customerUserList");
      this.close();
    },
    projectList() {
      this.$emit("menuSelected", "projectList");
      this.close();
    },
    accountDetails() {
      this.$emit("menuSelected", "accountDetails");
      this.close();
    },
    switchCustomer() {
      console.log("Switch customer");
      this.close();
      this.$auth.switchCustomer();
    },
    settingsMenu() {
      this.$emit("menuSelected", "settingsMenu");
      this.close();
    },
    logout() {
      this.$auth.logout();
    },
  },
};
</script>

<style scoped>
#menu {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 100%;
}
</style>